import { Accordion } from "#src/common/system/Accordion";
import { CheckboxLooksLikeRadioV2 } from "#src/commonV2/inputs/CheckboxLooksLikeRadio";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { VatTypeValue } from "#src/services/payment/enum";
import { IVatInvoiceRenderProps } from "./types";
import { MultipleChoiceBlockV2 } from "#src/commonV2/inputs/MultipleChoiceBlock";
import { RadioV2 } from "#src/commonV2/inputs/Radio";
import { FormInput } from "#src/commonV2/form/Input/FormInput";

interface IPaymentEnterInformationVatInvoiceProps {
  exportVatInvoice: boolean;
  setExportVatInvoice: Dispatch<SetStateAction<boolean>>;
  invoiceType: VatTypeValue;
  vatInvoiceFieldRenderProps: IVatInvoiceRenderProps;
}

export const PaymentEnterInformationVatInvoice = ({
  exportVatInvoice,
  setExportVatInvoice,
  invoiceType,
  vatInvoiceFieldRenderProps,
}: IPaymentEnterInformationVatInvoiceProps) => {
  const { t } = useTranslation("common", {
    keyPrefix: "v2.payment.enterInformation.vatInvoice",
  });

  // --------------- METHODS ---------------

  // --------------- RENDER ---------------

  return (
    <Accordion
      label={
        <label className="flex items-center gap-4 text-lg font-semibold text-gray-v2-900 cursor-pointer">
          <CheckboxLooksLikeRadioV2
            checked={exportVatInvoice}
            onClick={() => {
              setExportVatInvoice((prev) => !prev);
            }}
          />
          {t("title")}
        </label>
      }
      expanded={exportVatInvoice}
    >
      <div className="p-4 mt-5 flex flex-col gap-4 rounded-xl border border-gray-v2-200 bg-white">
        <span className="text-md text-gray-v2-600">{t("hint")}</span>
        <div className="grid grid-cols-2 gap-x-6 gap-y-4">
          <>
            <MultipleChoiceBlockV2
              selected={invoiceType === VatTypeValue.COMPANY}
              onSelect={() => {
                vatInvoiceFieldRenderProps.onChangeInvoiceType(
                  VatTypeValue.COMPANY
                );
              }}
            >
              <RadioV2 checked={invoiceType === VatTypeValue.COMPANY} />
              {t("company")}
            </MultipleChoiceBlockV2>
            <MultipleChoiceBlockV2
              selected={invoiceType === VatTypeValue.PERSONAL}
              onSelect={() => {
                vatInvoiceFieldRenderProps.onChangeInvoiceType(
                  VatTypeValue.PERSONAL
                );
              }}
            >
              <RadioV2 checked={invoiceType === VatTypeValue.PERSONAL} />
              {t("personal")}
            </MultipleChoiceBlockV2>
          </>
          {invoiceType === VatTypeValue.COMPANY ? (
            <>
              <FormInput {...vatInvoiceFieldRenderProps.companyName} />
              <FormInput {...vatInvoiceFieldRenderProps.taxCode} />
              <div className="col-span-2">
                <FormInput {...vatInvoiceFieldRenderProps.companyAddress} />
              </div>
            </>
          ) : (
            <>
              <FormInput {...vatInvoiceFieldRenderProps.fullName} />
              <FormInput {...vatInvoiceFieldRenderProps.citizenId} />
              <div className="col-span-2">
                <FormInput {...vatInvoiceFieldRenderProps.personalAddress} />
              </div>
            </>
          )}
        </div>
      </div>
    </Accordion>
  );
};
